import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { MainGoodsWithDiscount } from "../models/main-goods-with-discount.model";
import { LocalStorageService } from "./local-storage.service";

@Injectable()
export class CartService {
    private cart: MainGoodsWithDiscount[] = [];
    private cartCounter$ = new BehaviorSubject<number>(this.cart.length);
    
    constructor(
        public readonly localStorageService: LocalStorageService,
        ) {
        this.cart = this.localStorageService.getItem('cart') ? JSON.parse(this.localStorageService.getItem('cart')) : this.cart;
        this.setCounter(this.getLength());
    }

    addToCart(item: MainGoodsWithDiscount) {
        let ni = this.cart.find(c => c.id === item.id);
        if(ni){
            ni.count = ni.count + 1;
        } else {
            this.cart.push(item);
        }
        this.localStorageService.setItem('cart', JSON.stringify(this.cart))
        this.setCounter(this.getLength());
    }

    saveCart(cart: MainGoodsWithDiscount[]) {
        this.cart = cart;
        this.localStorageService.setItem('cart', JSON.stringify(this.cart))
        this.setCounter(this.getLength());        
    }

    getLength() {
        let r = 0;
        this.cart.forEach(c => {
            r = r + c.count;
        });
        return r;
    }

    setCounter(c: number) {
        this.cartCounter$.next(c);
    }

    getCounter(): Observable<number> {
        return this.cartCounter$.asObservable();
    }

    getCart() {
        return this.cart;
    }

    clear() {
        this.cart = [];
        this.setCounter(0);
        return this.localStorageService.clearStorage();
    }
}